export default RAILS_ASSET_URL("/poppins-v15-latin-500.woff2")
